<template>
  <div class="common-layout">
    <el-container class="layout-shell">
      <el-aside width="200px" class="sidebar-container"><MenuView/></el-aside>
      <el-container class="content-shell">
        <el-header class="header-container"><HeaderView/></el-header>
        <el-main class="main-container">
          <div class="tabs-container">
            <TabsView />
          </div>
          <div class="page-container">
            <router-view />
          </div>
        </el-main>
        <el-footer class="footer-container"><FooterView/></el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import MenuView from '@/layout/menu'
import HeaderView from '@/layout/header'
import FooterView from '@/layout/footer'
import TabsView from '@/layout/tabs'
import router from '@/router'
export default {
  name : "HomeView",
  components: {MenuView,HeaderView,FooterView, TabsView},
  mounted(){
    let token = window.sessionStorage.getItem('token')
    if (token == '' || token == null) {
      router.replace('/login')
    }
  }
}



</script>

<style lang="scss" scoped>
.common-layout {
  height: 100%;
  position: relative;
  width: 100%;
  overflow: hidden;
}

.layout-shell {
  height: 100%;
  overflow: hidden;
}

.content-shell {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.sidebar-container {
  background-color: #2d3a4b;
  height: 100%;
  overflow: auto;
}

.header-container {
  padding-left: 0;
  padding-right: 0;
}

.main-container {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.tabs-container {
  flex-shrink: 0;
  padding: 12px 20px 0;
  background-color: #f5f5f5;
}

.page-container {
  flex: 1;
  min-height: 0;
  overflow: auto;
  background-color: #f5f5f5;
}

.footer-container {
  flex-shrink: 0;
}

:deep(ul.el-menu) {
  border-right-width: 0;
}
</style>
